import { useEffect, useState } from "react";

const imageLoaders = new Map<string, () => Promise<{ default: string }>>([
  ["visa", () => import("../../assets/images/visa.webp")],
  ["mastercard", () => import("../../assets/images/mastercard.webp")],
  ["american-express", () => import("../../assets/images/american-express.webp")],
  ["pairing-screen", () => import("../../assets/images/pairing-screen.webp")],
  [
    "wayfinder_paringCode_ex",
    () => import("../../assets/images/wayfinder_paringCode_ex.webp"),
  ],
]);

const useImage = (fileName: string) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [image, setImage] = useState("");

  useEffect(() => {
    const fetchImage = async () => {
      try {
        setLoading(true);
        const loadImage = imageLoaders.get(fileName);
        if (!loadImage) throw new Error("Unknown image");
        const response = await loadImage();
        setImage(response.default);
      } catch (err) {
        setError("Error loading image");
      } finally {
        setLoading(false);
      }
    };

    fetchImage();
  }, [fileName]);

  return {
    loading,
    error,
    image,
  };
};

export default useImage;
